import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';

import LearningScreen from '../components/LearningScreen';
import storage from '../../../../../lib/Storage';
import { careGuideSetAccess } from '../../../../../state/modules/careGuides/actions';
import { findStorageType } from '../../../../../lib/Auth';

const moduleSerieTypes = [
  {
    action: 'progress',
    value: true,
  },
  {
    action: 'recommended',
    value: true,
  },
  {
    action: 'recommended_not',
    value: false,
  },
];
const mapStateToProps = (state, ownProps) => {
  const activeId = state.careGuides.get('activeId') ?? ownProps.match.params.id;

  const careGuide = activeId
    ? denormalize(
        state.entities.getIn(['careGuides', activeId]),
        schema.careGuide,
        state.entities.toJS()
      )
    : null;

  let total = 0;

  moduleSerieTypes.forEach((x) => {
    total += state.learnings.get(`totalModuleSeries_${x.action}`) || 0;
  });

  return {
    total,
    careGuide: careGuide,
    moduleSerieTypes: moduleSerieTypes,
    careGuideId: activeId,
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    isCareGuideLoading: careGuide === undefined ? true : false,
    isCareGuideActive:
      careGuide && careGuide.account && careGuide.account.is_subscription_valid,
    isLoading: state.learnings.get('isLoading'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setActiveAccess: (data) => {
      dispatch(careGuideSetAccess(data));
    },
  };
};

const LearningScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningScreen);

export default LearningScreenContainer;
